import Classic from './classic'

const TextArea = {
  Classic
}

export default TextArea
